/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import css from "../styles/Card.module.scss";
import classNames from "classnames";
import numeral from "numeral";
import Plane from "./Plane";
import Plane2 from "./Plane2";

const Card = ({
	card,
	timings,
	setTimings,
	setOldCoeffs,
	bcCoeffs,
	setCard,
	firstDuration,
	secondDuration,
	setLimit,
	limit,
}) => {
	const [iterator, setIterator] = useState(0);
	const [oldCoeff, setOldCoeff] = useState({});

	useEffect(() => {
		if (card.card === 3 || card.card === 4 || card.card === 5 || card.card === 6) {
			setOldCoeff({ coeff: card.coeff, coeff2: card.coeff2 });
		}

		changeMetrics();
	}, [card]);

	const getRandomNumber = (min, max) => {
		return Math.random() * (max - min) + min;
	};

	const changeMetrics = () => {
		if (card.card === 2) {
			const timeoutId = setTimeout(() => {
				setCard({ ...card, card: 3 });
			}, firstDuration);

			return () => clearTimeout(timeoutId);
		}
		if (card.card === 3) {
			if (timings[0] === timings[1]) {
				const timeoutId = setTimeout(() => {
					setCard({ ...card, card: 5 });
				}, timings[0] * 1000);

				return () => clearTimeout(timeoutId);
			}
			if (timings[0] < timings[1]) {
				const timeoutId = setTimeout(() => {
					setCard({ ...card, card: 4 });
				}, timings[0] * 1000);

				return () => clearTimeout(timeoutId);
			}
			if (timings[0] > timings[1]) {
				const timeoutId = setTimeout(() => {
					setCard({ ...card, card: 6 });
				}, timings[1] * 1000);

				return () => clearTimeout(timeoutId);
			}
		}
		if (card.card === 4) {
			const timeoutId = setTimeout(() => {
				setCard({ ...card, card: 5 });
			}, (timings[1] - timings[0]) * 1000);

			return () => clearTimeout(timeoutId);
		}

		if (card.card === 5) {
			setOldCoeffs(prev => [
				{
					coefficient: bcCoeffs[0] < bcCoeffs[1] ? bcCoeffs[1] : bcCoeffs[0],
					id: `id-${bcCoeffs[0]}-${getRandomNumber(0, 99999)}`,
					users: getRandomNumber(876, 4567),
					winners: getRandomNumber(120767, 789974),
				},
				...prev,
			]);

			const timeoutId = setTimeout(() => {
				setLimit(prev => {
					return { ...prev, numberOfLimit: prev.numberOfLimit - 1 };
				});
				setCard({ card: 1 });
			}, secondDuration);

			return () => clearTimeout(timeoutId);
		}
		if (card.card === 6) {
			setOldCoeffs(prev => [
				{
					coefficient: bcCoeffs[1],
					id: `id-${bcCoeffs[1]}-${getRandomNumber(0, 99999)}`,
					users: getRandomNumber(876, 4567),
					winners: getRandomNumber(120767, 789974),
				},
				...prev,
			]);

			const timeoutId = setTimeout(() => {
				setLimit(prev => {
					return { ...prev, numberOfLimit: prev.numberOfLimit - 1 };
				});
				setCard({ card: 1 });
			}, secondDuration);

			return () => clearTimeout(timeoutId);
		}
	};

	return (
		<section className={classNames(css.cardContainer, "uiCardContainer")}>
			<div className={classNames(css.card, css.card_1, card.card !== 1 && css._hidden, css._move)}>
				<span className={css.title}>Get started</span>
				{limit.unlimit && (
					<div
						className={classNames(css.energyContainer, css._unlim, card.card !== 1 && css._toSmall)}
					>
						<div className={css.bg} />
						<div className={css.content}>
							<span>UNLIM</span>
						</div>
					</div>
				)}
				{!limit.unlimit && (
					<div
						className={classNames(
							css.energyContainer,
							limit.numberOfLimit === 0 && css._energyContainer_2,
							card.card !== 1 && css._toSmall,
						)}
					>
						<div className={css.bg} />
						<div className={css.content}>
							<span>{limit.numberOfLimit}</span>
						</div>
					</div>
				)}
				<p className={css.text}>
					To get predict, click the <br /> "<span>PREDICT</span>" button
				</p>
			</div>
			<div className={classNames(css.card, css.card_2, card.card !== 2 && css._hidden, css._move)}>
				<div className={css.dotsContainer}>
					<div className={css.dotsLeft}>
						<span></span>
						<span></span>
						<span></span>
					</div>
					<div className={css.dotsRight}>
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>
				<span className={css.title}>Place your bet</span>
				<div className={classNames(css.propContainer, card.card !== 2 && css._toSmall)}>
					<div className={css.prop}>
						<svg
							width="96"
							height="95"
							viewBox="0 0 96 95"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M52.9263 53.4883C54.1271 52.5577 55.025 51.297 55.5086 49.8628L69.0789 46.9163C69.4261 46.8407 69.7399 46.6577 69.9755 46.3933L94.2469 19.1246C94.5067 18.833 94.6547 18.4598 94.6653 18.0704C94.6758 17.681 94.5481 17.3 94.3045 16.994L88.5639 9.78403C88.2882 9.43789 87.8855 9.2143 87.4442 9.16242C87.003 9.11054 86.5593 9.23461 86.2108 9.50737L77.4029 16.4051C61.9923 1.97164 38.166 0.846433 21.4342 13.949C18.7573 16.0436 16.3412 18.4468 14.2368 21.1082C13.963 21.4549 13.8395 21.8956 13.8933 22.3333C13.9471 22.771 14.174 23.1699 14.5239 23.4422C14.8738 23.7145 15.3182 23.8379 15.7592 23.7853C16.2002 23.7327 16.6018 23.5084 16.8756 23.1617C18.8162 20.7078 21.0443 18.492 23.5128 16.5607C38.8072 4.58319 60.5315 5.49984 74.7452 18.4865L70.21 22.0381C64.4969 17.1052 57.2365 14.202 49.6169 13.8324C41.4634 13.4388 33.447 15.9842 27.0467 20.9989C25.2993 22.3669 23.6915 23.9017 22.2463 25.5813C21.9659 25.9174 21.8302 26.3498 21.8686 26.785C21.907 27.2201 22.1164 27.6231 22.4516 27.9069C22.7867 28.1906 23.2206 28.3324 23.6596 28.3014C24.0986 28.2705 24.5074 28.0694 24.7977 27.7416C26.1004 26.2274 27.5499 24.8438 29.1253 23.6107C40.4102 14.7724 56.5986 15.0968 67.5301 24.1368L62.1243 28.3702C58.1452 25.4723 53.362 23.8657 48.4312 23.7709C42.9414 23.6755 37.5904 25.4638 33.2825 28.8334C32.9458 29.1101 32.7318 29.5068 32.6862 29.9385C32.6406 30.3703 32.7671 30.8029 33.0386 31.1439C33.31 31.4849 33.705 31.7073 34.139 31.7635C34.573 31.8196 35.0116 31.7051 35.3611 31.4445C42.328 25.9892 52.1148 25.7051 59.38 30.5206L47.7893 39.5964C46.1049 39.6405 44.4806 40.2218 43.1571 41.2542C41.9558 42.185 41.0575 43.4463 40.574 44.8811L27.0037 47.8275C26.6564 47.9031 26.3427 48.0855 26.1079 48.3499L1.83578 75.6185C1.57621 75.9101 1.42826 76.2831 1.41775 76.6724C1.40724 77.0617 1.53484 77.4425 1.77829 77.7484L7.5188 84.9584C7.65507 85.1301 7.82413 85.2735 8.01627 85.3803C8.20842 85.4871 8.41986 85.5552 8.63846 85.5807C9.06449 85.6308 9.50957 85.5188 9.87191 85.2351L18.6799 78.3373C25.3787 84.6022 33.9302 88.5617 43.0659 89.6284C48.661 90.2917 54.331 89.8528 59.7507 88.3367C65.1704 86.8206 70.2331 84.2572 74.6485 80.7935C76.7492 79.149 78.6909 77.3141 80.4486 75.3124C80.5929 75.1479 80.703 74.9568 80.7728 74.7499C80.8425 74.543 80.8705 74.3244 80.8551 74.1067C80.8397 73.8889 80.7812 73.6762 80.683 73.4807C80.5848 73.2852 80.4488 73.1108 80.2827 72.9673C80.1166 72.8239 79.9238 72.7142 79.7152 72.6446C79.5065 72.5751 79.2862 72.5469 79.0668 72.5618C78.8474 72.5767 78.6331 72.6343 78.4363 72.7314C78.2394 72.8285 78.0639 72.9631 77.9196 73.1276C76.2983 74.9736 74.5073 76.6658 72.5699 78.1825C57.251 90.1785 35.5556 89.2546 21.3352 76.2579L25.8721 72.7043C31.6371 77.6737 38.9223 80.5667 46.5446 80.9136C54.6719 81.2864 62.6569 78.7406 69.0361 73.7428C70.5293 72.5736 71.9212 71.2825 73.1973 69.883C73.4948 69.5562 73.6492 69.1253 73.6264 68.685C73.6036 68.2447 73.4054 67.8311 73.0756 67.5352C72.7457 67.2393 72.3111 67.0854 71.8674 67.1072C71.4238 67.129 71.0073 67.3249 70.7097 67.6516C69.559 68.9133 68.304 70.0772 66.9576 71.1311C55.6908 79.955 39.4786 79.6379 28.5527 70.6056L33.96 66.371C37.9493 69.2767 42.7467 70.8842 47.6904 70.9718C53.1665 71.0585 58.5022 69.2714 62.8 65.9111C63.1406 65.6357 63.3582 65.2382 63.4057 64.8044C63.4533 64.3706 63.327 63.9354 63.0542 63.5926C62.7814 63.2498 62.3839 63.027 61.9475 62.9721C61.5111 62.9172 61.0707 63.0348 60.7215 63.2994C53.7624 68.7499 43.9652 69.0363 36.7024 64.2246L48.2934 55.1467C49.978 55.1028 51.6025 54.5215 52.9262 53.489L52.9263 53.4883ZM86.9757 13.1473L90.8081 17.9612L67.8231 43.7843L55.8508 46.383C55.6668 44.9826 55.0998 43.6583 54.2112 42.5539C53.5791 41.7631 52.7982 41.1018 51.912 40.6067L86.9757 13.1473ZM9.10704 81.5952L5.27465 76.7812L28.2596 50.9581L40.232 48.3595C40.4159 49.7599 40.983 51.0842 41.8716 52.1886C42.5036 52.9793 43.2846 53.6406 44.1708 54.1357L9.10704 81.5952ZM44.4941 50.1246C44.125 49.6668 43.8512 49.1408 43.6889 48.5773C43.5265 48.0139 43.4787 47.4242 43.5482 46.8426L43.5581 46.7766C43.5994 46.6458 43.6232 46.5108 43.6309 46.3717C43.8567 45.3794 44.4214 44.4956 45.2294 43.8702C46.172 43.1358 47.3705 42.8033 48.5617 42.9458C49.7534 43.0835 50.8421 43.6849 51.5886 44.6179C51.9578 45.0757 52.2315 45.6017 52.3939 46.1651C52.5563 46.7286 52.6041 47.3183 52.5345 47.8999L52.5246 47.9658C52.4834 48.0972 52.4589 48.2332 52.4518 48.3707C52.226 49.3631 51.6613 50.2468 50.8533 50.8722C48.8959 52.3975 46.0437 52.0614 44.4941 50.1246Z"
								fill="white"
								fillOpacity="0.12"
							/>
							<path
								d="M52.9263 53.4883C54.1271 52.5577 55.025 51.297 55.5086 49.8628L69.0789 46.9163C69.4261 46.8407 69.7399 46.6577 69.9755 46.3933L94.2469 19.1246C94.5067 18.833 94.6547 18.4598 94.6653 18.0704C94.6758 17.681 94.5481 17.3 94.3045 16.994L88.5639 9.78403C88.2882 9.43789 87.8855 9.2143 87.4442 9.16242C87.003 9.11054 86.5593 9.23461 86.2108 9.50737L77.4029 16.4051C61.9923 1.97164 38.166 0.846433 21.4342 13.949C18.7573 16.0436 16.3412 18.4468 14.2368 21.1082C13.963 21.4549 13.8395 21.8956 13.8933 22.3333C13.9471 22.771 14.174 23.1699 14.5239 23.4422C14.8738 23.7145 15.3182 23.8379 15.7592 23.7853C16.2002 23.7327 16.6018 23.5084 16.8756 23.1617C18.8162 20.7078 21.0443 18.492 23.5128 16.5607C38.8072 4.58319 60.5315 5.49984 74.7452 18.4865L70.21 22.0381C64.4969 17.1052 57.2365 14.202 49.6169 13.8324C41.4634 13.4388 33.447 15.9842 27.0467 20.9989C25.2993 22.3669 23.6915 23.9017 22.2463 25.5813C21.9659 25.9174 21.8302 26.3498 21.8686 26.785C21.907 27.2201 22.1164 27.6231 22.4516 27.9069C22.7867 28.1906 23.2206 28.3324 23.6596 28.3014C24.0986 28.2705 24.5074 28.0694 24.7977 27.7416C26.1004 26.2274 27.5499 24.8438 29.1253 23.6107C40.4102 14.7724 56.5986 15.0968 67.5301 24.1368L62.1243 28.3702C58.1452 25.4723 53.362 23.8657 48.4312 23.7709C42.9414 23.6755 37.5904 25.4638 33.2825 28.8334C32.9458 29.1101 32.7318 29.5068 32.6862 29.9385C32.6406 30.3703 32.7671 30.8029 33.0386 31.1439C33.31 31.4849 33.705 31.7073 34.139 31.7635C34.573 31.8196 35.0116 31.7051 35.3611 31.4445C42.328 25.9892 52.1148 25.7051 59.38 30.5206L47.7893 39.5964C46.1049 39.6405 44.4806 40.2218 43.1571 41.2542C41.9558 42.185 41.0575 43.4463 40.574 44.8811L27.0037 47.8275C26.6564 47.9031 26.3427 48.0855 26.1079 48.3499L1.83578 75.6185C1.57621 75.9101 1.42826 76.2831 1.41775 76.6724C1.40724 77.0617 1.53484 77.4425 1.77829 77.7484L7.5188 84.9584C7.65507 85.1301 7.82413 85.2735 8.01627 85.3803C8.20842 85.4871 8.41986 85.5552 8.63846 85.5807C9.06449 85.6308 9.50957 85.5188 9.87191 85.2351L18.6799 78.3373C25.3787 84.6022 33.9302 88.5617 43.0659 89.6284C48.661 90.2917 54.331 89.8528 59.7507 88.3367C65.1704 86.8206 70.2331 84.2572 74.6485 80.7935C76.7492 79.149 78.6909 77.3141 80.4486 75.3124C80.5929 75.1479 80.703 74.9568 80.7728 74.7499C80.8425 74.543 80.8705 74.3244 80.8551 74.1067C80.8397 73.8889 80.7812 73.6762 80.683 73.4807C80.5848 73.2852 80.4488 73.1108 80.2827 72.9673C80.1166 72.8239 79.9238 72.7142 79.7152 72.6446C79.5065 72.5751 79.2862 72.5469 79.0668 72.5618C78.8474 72.5767 78.6331 72.6343 78.4363 72.7314C78.2394 72.8285 78.0639 72.9631 77.9196 73.1276C76.2983 74.9736 74.5073 76.6658 72.5699 78.1825C57.251 90.1785 35.5556 89.2546 21.3352 76.2579L25.8721 72.7043C31.6371 77.6737 38.9223 80.5667 46.5446 80.9136C54.6719 81.2864 62.6569 78.7406 69.0361 73.7428C70.5293 72.5736 71.9212 71.2825 73.1973 69.883C73.4948 69.5562 73.6492 69.1253 73.6264 68.685C73.6036 68.2447 73.4054 67.8311 73.0756 67.5352C72.7457 67.2393 72.3111 67.0854 71.8674 67.1072C71.4238 67.129 71.0073 67.3249 70.7097 67.6516C69.559 68.9133 68.304 70.0772 66.9576 71.1311C55.6908 79.955 39.4786 79.6379 28.5527 70.6056L33.96 66.371C37.9493 69.2767 42.7467 70.8842 47.6904 70.9718C53.1665 71.0585 58.5022 69.2714 62.8 65.9111C63.1406 65.6357 63.3582 65.2382 63.4057 64.8044C63.4533 64.3706 63.327 63.9354 63.0542 63.5926C62.7814 63.2498 62.3839 63.027 61.9475 62.9721C61.5111 62.9172 61.0707 63.0348 60.7215 63.2994C53.7624 68.7499 43.9652 69.0363 36.7024 64.2246L48.2934 55.1467C49.978 55.1028 51.6025 54.5215 52.9262 53.489L52.9263 53.4883ZM86.9757 13.1473L90.8081 17.9612L67.8231 43.7843L55.8508 46.383C55.6668 44.9826 55.0998 43.6583 54.2112 42.5539C53.5791 41.7631 52.7982 41.1018 51.912 40.6067L86.9757 13.1473ZM9.10704 81.5952L5.27465 76.7812L28.2596 50.9581L40.232 48.3595C40.4159 49.7599 40.983 51.0842 41.8716 52.1886C42.5036 52.9793 43.2846 53.6406 44.1708 54.1357L9.10704 81.5952ZM44.4941 50.1246C44.125 49.6668 43.8512 49.1408 43.6889 48.5773C43.5265 48.0139 43.4787 47.4242 43.5482 46.8426L43.5581 46.7766C43.5994 46.6458 43.6232 46.5108 43.6309 46.3717C43.8567 45.3794 44.4214 44.4956 45.2294 43.8702C46.172 43.1358 47.3705 42.8033 48.5617 42.9458C49.7534 43.0835 50.8421 43.6849 51.5886 44.6179C51.9578 45.0757 52.2315 45.6017 52.3939 46.1651C52.5563 46.7286 52.6041 47.3183 52.5345 47.8999L52.5246 47.9658C52.4834 48.0972 52.4589 48.2332 52.4518 48.3707C52.226 49.3631 51.6613 50.2468 50.8533 50.8722C48.8959 52.3975 46.0437 52.0614 44.4941 50.1246Z"
								fill="url(#paint0_linear_101_50812r)"
							/>
							<path
								d="M84.0895 67.3594C83.7115 67.1272 83.2563 67.0533 82.8239 67.1539C82.3916 67.2545 82.0176 67.5214 81.784 67.896L81.7609 67.934C81.6465 68.1203 81.5704 68.3272 81.5367 68.5429C81.503 68.7585 81.5125 68.9788 81.5646 69.191C81.6167 69.4032 81.7104 69.6032 81.8403 69.7796C81.9702 69.956 82.1339 70.1053 82.3218 70.2191C82.5098 70.3329 82.7185 70.4088 82.9359 70.4427C83.1533 70.4765 83.3752 70.4675 83.589 70.4162C83.8027 70.3649 84.0041 70.2723 84.1817 70.1437C84.3592 70.0151 84.5095 69.853 84.6238 69.6667L84.6353 69.6481C84.8686 69.2733 84.9421 68.8217 84.8398 68.3925C84.7374 67.9633 84.4676 67.5917 84.0895 67.3594ZM12.878 25.9231C12.492 25.7044 12.0345 25.6466 11.6062 25.7624C11.1779 25.8783 10.8138 26.1582 10.594 26.5408L10.5749 26.5743C10.4416 26.8124 10.3696 27.0796 10.3652 27.3521C10.3608 27.6247 10.4242 27.8942 10.5497 28.1369C10.6753 28.3796 10.8592 28.588 11.0851 28.7435C11.311 28.8991 11.5719 28.9971 11.8448 29.0288C12.4995 29.1058 13.1685 28.7917 13.5082 28.186C13.9618 27.3895 13.6804 26.3781 12.878 25.9231Z"
								fill="white"
								fillOpacity="0.12"
							/>
							<path
								d="M84.0895 67.3594C83.7115 67.1272 83.2563 67.0533 82.8239 67.1539C82.3916 67.2545 82.0176 67.5214 81.784 67.896L81.7609 67.934C81.6465 68.1203 81.5704 68.3272 81.5367 68.5429C81.503 68.7585 81.5125 68.9788 81.5646 69.191C81.6167 69.4032 81.7104 69.6032 81.8403 69.7796C81.9702 69.956 82.1339 70.1053 82.3218 70.2191C82.5098 70.3329 82.7185 70.4088 82.9359 70.4427C83.1533 70.4765 83.3752 70.4675 83.589 70.4162C83.8027 70.3649 84.0041 70.2723 84.1817 70.1437C84.3592 70.0151 84.5095 69.853 84.6238 69.6667L84.6353 69.6481C84.8686 69.2733 84.9421 68.8217 84.8398 68.3925C84.7374 67.9633 84.4676 67.5917 84.0895 67.3594ZM12.878 25.9231C12.492 25.7044 12.0345 25.6466 11.6062 25.7624C11.1779 25.8783 10.8138 26.1582 10.594 26.5408L10.5749 26.5743C10.4416 26.8124 10.3696 27.0796 10.3652 27.3521C10.3608 27.6247 10.4242 27.8942 10.5497 28.1369C10.6753 28.3796 10.8592 28.588 11.0851 28.7435C11.311 28.8991 11.5719 28.9971 11.8448 29.0288C12.4995 29.1058 13.1685 28.7917 13.5082 28.186C13.9618 27.3895 13.6804 26.3781 12.878 25.9231Z"
								fill="url(#paint1_linear_101_50812r)"
							/>
							<defs>
								<linearGradient
									id="paint0_linear_101_50812r"
									x1="5.44552"
									y1="42.3572"
									x2="90.6389"
									y2="52.3735"
									gradientUnits="userSpaceOnUse"
								>
									<stop stopColor="#F2994A" />
									<stop
										offset="1"
										stopColor="#F2C94C"
									/>
								</linearGradient>
								<linearGradient
									id="paint1_linear_101_50812r"
									x1="8.46066"
									y1="43.4792"
									x2="86.7876"
									y2="52.6882"
									gradientUnits="userSpaceOnUse"
								>
									<stop stopColor="#F2994A" />
									<stop
										offset="1"
										stopColor="#F2C94C"
									/>
								</linearGradient>
							</defs>
						</svg>
					</div>
				</div>
				<div className={classNames(css.coeffs, css._c1)}>
					<div className={classNames(css.border)} />
					<div className={classNames(css.coeff)}>
						<div className={css._c1}>
							<span>{numeral(card.coeff).format("0.00")}x</span>
							<span>prediction</span>
						</div>
					</div>
				</div>
			</div>
			<div className={classNames(css.card, css.card_1, card.card !== 3 && css._hidden, css._move)}>
				<span className={css.title}>round is on</span>
				<div
					className={classNames(css.planeContainer, card.card === 3 && css._fly, css._movePlane1)}
				>
					<Plane card={card} />
				</div>
				<div className={classNames(css.coeffs, css._c2)}>
					<div className={classNames(css.border)} />
					<div className={classNames(css.coeff)}>
						<div className={""}>
							<span>{numeral(card.coeff).format("0.00")}x</span>
							<span>prediction</span>
						</div>
					</div>
				</div>
			</div>
			<div className={classNames(css.card, css.card_3, card.card !== 4 && css._hidden, css._move)}>
				<div className={css.winContainer}>
					<span
						className={classNames(
							css.w1,
							card.card === 4 && css._visibleW1,
							card.card !== 4 && css._hiddenW1,
						)}
					>
						win
					</span>
					<span
						className={classNames(
							css.w2,
							card.card === 4 && css._visibleW2,
							card.card !== 4 && css._hiddenW2,
						)}
					>
						win
					</span>
					<span
						className={classNames(
							css.w3,
							card.card === 4 && css._visibleW3,
							card.card !== 4 && css._hiddenW3,
						)}
					>
						win
					</span>
					<span
						className={classNames(
							css.w4,
							card.card === 4 && css._visibleW4,
							card.card !== 4 && css._hiddenW4,
						)}
					>
						win
					</span>
				</div>
				<span className={css.title}>round is on</span>
				<div
					className={classNames(
						css.planeContainer,
						card.card === 4 && css._toLargePlane,
						card.card !== 4 && css._toSmall,
						css._movePlane1,
					)}
				>
					<Plane2
						card={card}
						color2={"rgba(7, 221, 114, 1)"}
						color1="rgba(10, 209, 140, 1)"
					/>
				</div>
				<div className={classNames(css.coeffs, css._c3)}>
					<div className={classNames(css.border)} />
					<div className={classNames(css.coeff)}>
						<div className={""}>
							<span>{numeral(card.coeff).format("0.00")}x</span>
							<span>prediction</span>
						</div>
					</div>
				</div>
			</div>
			<div
				className={classNames(
					css.card,
					css.card_3,
					css.card_5,
					card.card !== 5 && css._hidden,
					css._move,
				)}
			>
				<span className={css.title}>flew off</span>
				<div
					className={classNames(css.propContainer, card.card !== 5 && css._toSmall)}
					style={{ left: "calc(50% - 37.5px)", top: "64px" }}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="72"
						height="72"
						fill="none"
						viewBox="0 0 72 72"
					>
						<path
							fill="url(#a)"
							fillRule="evenodd"
							d="M36 0c19.882 0 36 16.118 36 36S55.882 72 36 72 0 55.882 0 36 16.118 0 36 0Zm0 7.2C20.094 7.2 7.2 20.094 7.2 36S20.094 64.8 36 64.8 64.8 51.906 64.8 36 51.906 7.2 36 7.2Zm11.854 15.454L28.8 41.71l-4.654-4.655a3.6 3.6 0 1 0-5.092 5.092l7.2 7.2a3.6 3.6 0 0 0 5.092 0l21.6-21.6a3.6 3.6 0 1 0-5.092-5.092Z"
							clipRule="evenodd"
						/>
						<defs>
							<linearGradient
								id="a"
								x1="62.535"
								x2="-9.71"
								y1="-2.731"
								y2="22.475"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#07DD72" />
								<stop
									offset="1"
									stopColor="#0AD18C"
								/>
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className={classNames(css.coeffs, css._c3)}>
					<div className={classNames(css.border)} />
					<div className={classNames(css.coeff)}>
						{oldCoeff.coeff === oldCoeff.coeff2 && (
							<>
								<div className={css._c2}>
									<span>{numeral(oldCoeff.coeff).format("0.00")}x</span>
									<span>prediction</span>
								</div>
								<div className={""}>
									<span>{numeral(oldCoeff.coeff).format("0.00")}x</span>
									<span>in the round</span>
								</div>
							</>
						)}
						{oldCoeff.coeff !== oldCoeff.coeff2 && (
							<>
								<div className={css._c2}>
									<span>{numeral(oldCoeff.coeff).format("0.00")}x</span>
									<span>prediction</span>
								</div>
								<div className={""}>
									<span>{numeral(oldCoeff.coeff2).format("0.00")}x</span>
									<span>in the round</span>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
			<div className={classNames(css.card, css.card_4, card.card !== 6 && css._hidden, css._move)}>
				<span className={css.title}>flew off</span>
				<div
					className={classNames(css.propContainer, card.card !== 6 && css._toSmall)}
					style={{ left: "calc(50% - 37.5px)", top: "64px" }}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="75"
						height="75"
						fill="none"
						viewBox="0 0 80 80"
					>
						<path
							fill="url(#a12)"
							fillRule="evenodd"
							d="M40 0c22.088 0 40 17.912 40 40S62.088 80 40 80 0 62.088 0 40 17.912 0 40 0Zm0 8C22.356 8 8 22.356 8 40s14.356 32 32 32 32-14.356 32-32S57.644 8 40 8Zm9.172 17.172 5.656 5.656L45.656 40l9.172 9.172-5.656 5.656L40 45.656l-9.172 9.172-5.656-5.656L34.344 40l-9.172-9.172 5.656-5.656L40 34.344l9.172-9.172Z"
							clipRule="evenodd"
						/>
						<defs>
							<linearGradient
								id="a12"
								x1="69.484"
								x2="-10.789"
								y1="-3.034"
								y2="24.972"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#FF4747" />
								<stop
									offset="1"
									stopColor="#E50539"
								/>
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className={classNames(css.coeffs, css._c4)}>
					<div className={classNames(css.border)} />
					<div className={classNames(css.coeff)}>
						<div className={css._c3}>
							<span>{numeral(oldCoeff.coeff).format("0.00")}x</span>
							<span>prediction</span>
						</div>
						<div className={""}>
							<span>{numeral(oldCoeff.coeff2).format("0.00")}x</span>
							<span>in the round</span>
						</div>
					</div>
				</div>
			</div>
			<div className={classNames(css.card, css.card_1, card.card !== 7 && css._hidden, css._move)}>
				<div className={classNames(css.dotsContainer, css._t2)}>
					<div className={css.dotsLeft}>
						<span></span>
						<span></span>
						<span></span>
					</div>
					<div className={css.dotsRight}>
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>
				<span className={css.title}>Synchronization</span>
				<div className={css.propContainer}>
					<div className={classNames(css.prop)}>
						<svg
							width="96"
							height="95"
							viewBox="0 0 96 95"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M52.9261 53.4883C54.1268 52.5577 55.0248 51.297 55.5083 49.8628L69.0787 46.9163C69.4259 46.8407 69.7397 46.6577 69.9752 46.3933L94.2466 19.1246C94.5064 18.833 94.6545 18.4598 94.665 18.0704C94.6755 17.681 94.5478 17.3 94.3042 16.994L88.5637 9.78403C88.288 9.43789 87.8852 9.2143 87.444 9.16242C87.0027 9.11054 86.5591 9.23461 86.2106 9.50737L77.4026 16.4051C61.992 1.97164 38.1658 0.846433 21.434 13.949C18.757 16.0436 16.3409 18.4468 14.2366 21.1082C13.9628 21.4549 13.8392 21.8956 13.8931 22.3333C13.9469 22.771 14.1737 23.1699 14.5236 23.4422C14.8736 23.7145 15.3179 23.8379 15.7589 23.7853C16.2 23.7327 16.6015 23.5084 16.8753 23.1617C18.816 20.7078 21.044 18.492 23.5125 16.5607C38.8069 4.58319 60.5312 5.49984 74.7449 18.4865L70.2097 22.0381C64.4967 17.1052 57.2362 14.202 49.6167 13.8324C41.4632 13.4388 33.4468 15.9842 27.0464 20.9989C25.2991 22.3669 23.6913 23.9017 22.2461 25.5813C21.9657 25.9174 21.83 26.3498 21.8684 26.785C21.9068 27.2201 22.1162 27.6231 22.4513 27.9069C22.7865 28.1906 23.2204 28.3324 23.6594 28.3014C24.0984 28.2705 24.5072 28.0694 24.7974 27.7416C26.1002 26.2274 27.5497 24.8438 29.125 23.6107C40.41 14.7724 56.5983 15.0968 67.5299 24.1368L62.1241 28.3702C58.1449 25.4723 53.3617 23.8657 48.4309 23.7709C42.9412 23.6755 37.5901 25.4638 33.2822 28.8334C32.9455 29.1101 32.7315 29.5068 32.6859 29.9385C32.6403 30.3703 32.7668 30.8029 33.0383 31.1439C33.3098 31.4849 33.7048 31.7073 34.1388 31.7635C34.5728 31.8196 35.0114 31.7051 35.3609 31.4445C42.3277 25.9892 52.1146 25.7051 59.3798 30.5206L47.789 39.5964C46.1047 39.6405 44.4804 40.2218 43.1569 41.2542C41.9556 42.185 41.0573 43.4463 40.5738 44.8811L27.0034 47.8275C26.6562 47.9031 26.3425 48.0855 26.1077 48.3499L1.83554 75.6185C1.57596 75.9101 1.42801 76.2831 1.4175 76.6724C1.40699 77.0617 1.5346 77.4425 1.77804 77.7484L7.51856 84.9584C7.65482 85.1301 7.82388 85.2735 8.01603 85.3803C8.20817 85.4871 8.41962 85.5552 8.63821 85.5807C9.06424 85.6308 9.50932 85.5188 9.87166 85.2351L18.6796 78.3373C25.3785 84.6022 33.9299 88.5617 43.0657 89.6284C48.6608 90.2917 54.3308 89.8528 59.7504 88.3367C65.1701 86.8206 70.2329 84.2572 74.6483 80.7935C76.7489 79.149 78.6906 77.3141 80.4484 75.3124C80.5927 75.1479 80.7028 74.9568 80.7725 74.7499C80.8423 74.543 80.8702 74.3244 80.8548 74.1067C80.8394 73.8889 80.7809 73.6762 80.6827 73.4807C80.5845 73.2852 80.4485 73.1108 80.2825 72.9673C80.1164 72.8239 79.9236 72.7142 79.7149 72.6446C79.5063 72.5751 79.286 72.5469 79.0666 72.5618C78.8471 72.5767 78.6329 72.6343 78.436 72.7314C78.2392 72.8285 78.0636 72.9631 77.9194 73.1276C76.298 74.9736 74.5071 76.6658 72.5696 78.1825C57.2507 90.1785 35.5554 89.2546 21.3349 76.2579L25.8718 72.7043C31.6369 77.6737 38.922 80.5667 46.5443 80.9136C54.6716 81.2864 62.6567 78.7406 69.0359 73.7428C70.529 72.5736 71.9209 71.2825 73.197 69.883C73.4946 69.5562 73.649 69.1253 73.6261 68.685C73.6033 68.2447 73.4052 67.8311 73.0753 67.5352C72.7454 67.2393 72.3109 67.0854 71.8672 67.1072C71.4235 67.129 71.0071 67.3249 70.7095 67.6516C69.5588 68.9133 68.3037 70.0772 66.9573 71.1311C55.6906 79.955 39.4784 79.6379 28.5524 70.6056L33.9598 66.371C37.949 69.2767 42.7464 70.8842 47.6902 70.9718C53.1663 71.0585 58.502 69.2714 62.7998 65.9111C63.1404 65.6357 63.3579 65.2382 63.4055 64.8044C63.453 64.3706 63.3268 63.9354 63.054 63.5926C62.7812 63.2498 62.3836 63.027 61.9472 62.9721C61.5108 62.9172 61.0705 63.0348 60.7212 63.2994C53.7621 68.7499 43.9649 69.0363 36.7021 64.2246L48.2931 55.1467C49.9777 55.1028 51.6023 54.5215 52.926 53.489L52.9261 53.4883ZM86.9755 13.1473L90.8079 17.9612L67.8229 43.7843L55.8505 46.383C55.6666 44.9826 55.0995 43.6583 54.2109 42.5539C53.5789 41.7631 52.7979 41.1018 51.9117 40.6067L86.9755 13.1473ZM9.10679 81.5952L5.2744 76.7812L28.2594 50.9581L40.2317 48.3595C40.4157 49.7599 40.9827 51.0842 41.8713 52.1886C42.5034 52.9793 43.2843 53.6406 44.1706 54.1357L9.10679 81.5952ZM44.4939 50.1246C44.1247 49.6668 43.851 49.1408 43.6886 48.5773C43.5262 48.0139 43.4784 47.4242 43.548 46.8426L43.5579 46.7766C43.5992 46.6458 43.623 46.5108 43.6307 46.3717C43.8565 45.3794 44.4212 44.4956 45.2292 43.8702C46.1717 43.1358 47.3703 42.8033 48.5614 42.9458C49.7531 43.0835 50.8419 43.6849 51.5884 44.6179C51.9575 45.0757 52.2313 45.6017 52.3937 46.1651C52.556 46.7286 52.6039 47.3183 52.5343 47.8999L52.5244 47.9658C52.4832 48.0972 52.4587 48.2332 52.4516 48.3707C52.2258 49.3631 51.6611 50.2468 50.8531 50.8722C48.8957 52.3975 46.0435 52.0614 44.4939 50.1246Z"
								fill="url(#paint0_linear_104_629)"
							/>
							<path
								d="M84.0893 67.3594C83.7112 67.1272 83.256 67.0533 82.8237 67.1539C82.3914 67.2545 82.0173 67.5214 81.7838 67.896L81.7606 67.934C81.6463 68.1203 81.5701 68.3272 81.5365 68.5429C81.5028 68.7585 81.5123 68.9788 81.5644 69.191C81.6165 69.4032 81.7101 69.6032 81.8401 69.7796C81.97 69.956 82.1336 70.1053 82.3216 70.2191C82.5096 70.3329 82.7182 70.4088 82.9356 70.4427C83.1531 70.4765 83.375 70.4675 83.5887 70.4162C83.8025 70.3649 84.0039 70.2723 84.1814 70.1437C84.359 70.0151 84.5092 69.853 84.6235 69.6667L84.6351 69.6481C84.8683 69.2733 84.9419 68.8217 84.8395 68.3925C84.7372 67.9633 84.4673 67.5917 84.0893 67.3594ZM12.8778 25.9231C12.4918 25.7044 12.0343 25.6466 11.606 25.7624C11.1776 25.8783 10.8135 26.1582 10.5937 26.5408L10.5747 26.5743C10.4414 26.8124 10.3693 27.0796 10.3649 27.3521C10.3605 27.6247 10.4239 27.8942 10.5495 28.1369C10.6751 28.3796 10.8589 28.588 11.0848 28.7435C11.3107 28.8991 11.5717 28.9971 11.8446 29.0288C12.4993 29.1058 13.1682 28.7917 13.5079 28.186C13.9615 27.3895 13.6802 26.3781 12.8778 25.9231Z"
								fill="url(#paint1_linear_104_629)"
							/>
							<defs>
								<linearGradient
									id="paint0_linear_104_629"
									x1="84.7855"
									y1="5.58681"
									x2="-4.07943"
									y2="25.5612"
									gradientUnits="userSpaceOnUse"
								>
									<stop stopColor="#FF4747" />
									<stop
										offset="1"
										stopColor="#E50539"
									/>
								</linearGradient>
								<linearGradient
									id="paint1_linear_104_629"
									x1="78.7626"
									y1="32.1551"
									x2="17.9274"
									y2="68.0721"
									gradientUnits="userSpaceOnUse"
								>
									<stop stopColor="#FF4747" />
									<stop
										offset="1"
										stopColor="#E50539"
									/>
								</linearGradient>
							</defs>
						</svg>
					</div>
				</div>
				<p className={css.text}>
					Wait, the next rounds are being <br /> analyzed
				</p>
			</div>
		</section>
	);
};

export default Card;
